import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-f67427da")

_pushScopeId("data-v-f67427da")
const _hoisted_1 = { class: "service-list" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "service-list-divider" }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_ServiceListItem = _resolveComponent("ServiceListItem")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.list, (item) => {
      return (_openBlock(), _createBlock(_component_ServiceListItem, {
        key: item.id,
        imageUrl: item.image.thumb,
        title: item.title,
        description: item.description,
        onOnClick: ($event: any) => (_ctx.selectUrlItem(item.id, item.title, item.contentsUrl, item.externalContentsFlg))
      }, null, 8, ["imageUrl", "title", "description", "onOnClick"]))
    }), 128 /* KEYED_FRAGMENT */))
  ]))
})